import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { lionSelectors, LionTranslate } from '@rosetta/react-lion';
import { authSelectors } from '@rosetta/react-auth';
import { withWindowDimensions } from '@rosetta/react-common-ui';
import { isCatalyst, isCatalystAdmin } from '../../../helpers/productConfigHelper';
import styled from '@emotion/styled';

import {
  appHeaderBackground,
  black,
  white,
  lightBlueColor,
  defaultBoxShadow,
  menuItemBorderColor
} from '../../../styles/colors';
import { appMinWidth, headerHeight, mobileHeaderHeight } from '../../../styles/constants';
import headerLogo from '../../../assets/images/header-logo.png';
import headerLogoCatalyst from '../../../assets/images/header-logo-rs-catalyst.png';
import greyArrowDown from '../../../assets/images/arrow-down-grey-solid.svg';
import userIcon from '../../../assets/images/user-icon.svg';
import { appActions, appSelectors } from '../reducer/app-reducer';
import { ModalDialog } from '../util/ModalDialog';
import { getLocation } from 'connected-react-router';
import { isMobile as isMobileDetected } from 'react-device-detect';

let isRtl = false;

const AppHeaderDiv = styled.div((props) => {
  let style = {
    background: appHeaderBackground,
    color: lightBlueColor,
    height: !props.isMobile ? headerHeight : mobileHeaderHeight,
    minWidth: !props.isMobile ? appMinWidth : '100%',
    fontSize: '12px',
    fontWeight: 'bold',
    position: !props.isMobile ? 'absolute' : 'relative',
    left: '0px',
    right: '0px',
    top: '0px',
    display: 'block',
    zIndex: '990'
  };
  return style;
});

const sideSpace = '20px';

const Logo = styled.div((props) => {
  let style = {
    marginTop: !props.isMobile ? '15px' : '10px',
    width: '180px',
    height: '32px',
    backgroundImage: 'url(' + headerLogo + ')',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '0px 0px'
  };
  if (isRtl) {
    style.float = 'right';
    style.marginLeft = '0px';
    style.marginRight = sideSpace;
  } else {
    style.float = 'left';
    style.marginLeft = sideSpace;
    style.marginRight = '0px';
  }

  if (props.isCatalyst) {
    style.marginTop = '0px';
    style.height = !props.isMobile ? '60px' : '50px';
    style.backgroundImage = 'url(' + headerLogoCatalyst + ')';
    style.backgroundPosition = '11px 7px';
    style.backgroundSize = !props.isMobile ? '127px 46px' : '99px 36px';
    style.marginLeft = '0px';
  }
  return style;
});

const UserMenu = styled.div((props) => {
  let style = {
    height: !props.isMobile ? headerHeight : mobileHeaderHeight,
    maxWidth: '280px',
    position: !props.isMobile ? 'absolute' : 'relative'
  };
  if (isRtl) {
    style.left = '0x';
    style.right = 'auto';
    style.textAlign = 'left';
  } else {
    style.right = '0px';
    style.left = 'auto';
    style.textAlign = 'right';
    style.float = !props.isMobile ? 'none' : 'right';
  }
  return style;
});

const MenuTop = styled.div((props) => {
  let style = {
    cursor: 'pointer',
    height: !props.isMobile ? headerHeight : mobileHeaderHeight
  };
  return style;
});

const UserName = styled.div((props) => {
  let style = {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    lineHeight: headerHeight,
    maxWidth: '185px',
    display: !props.isMobile ? 'block' : 'none'
  };
  if (isRtl) {
    style.float = 'left';
    style.paddingLeft = '15px';
    style.paddingTop = '3px';
    style.marginRight = '8px'; // to allow clickability past name itself
  } else {
    style.float = 'right';
    style.paddingRight = '15px';
    style.marginLeft = '8px'; // to allow clickability past name itself
  }

  return style;
});

const UserIcon = styled.div(() => {
  let style = {
    backgroundImage: 'url(' + userIcon + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    width: '36px',
    height: '36px',
    float: 'left',
    marginRight: '8px',
    marginTop: '10px'
  };
  return style;
});

const DownArrow = styled.div(() => {
  let style = {
    backgroundImage: 'url(' + greyArrowDown + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    width: '15px',
    height: '15px'
  };
  if (isRtl) {
    style.marginTop = '25px';
    style.float = 'left';
    style.marginLeft = '20px';
  } else {
    style.marginTop = '22px';
    style.float = 'right';
    style.marginRight = '20px';
  }
  return style;
});

const Dropdown = styled.div((props) => {
  let style = {
    top: !props.isMobile ? headerHeight : mobileHeaderHeight,
    position: 'absolute',
    background: white,
    minWidth: '120px',
    color: black,
    boxShadow: defaultBoxShadow
  };
  if (isRtl) {
    style.left = '20px';
    style.textAlign = 'right';
  } else {
    style.right = !props.isMobile ? '20px' : '5px';
    style.textAlign = 'left';
  }
  return style;
});

const MenuList = styled.ul(() => {
  let style = {
    listStyleType: 'none',
    fontSize: '12px',
    margin: '0px',
    padding: '0px'
  };
  return style;
});

const MenuItem = styled.li(() => {
  let style = {
    lineHeight: '40px',
    whiteSpace: 'nowrap',
    height: '40px',
    fontWeight: 'normal',
    borderTopColor: menuItemBorderColor,
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    ':hover': {
      cursor: 'pointer',
      backgroundColor: lightBlueColor,
      color: white,
      fontWeight: 'bold'
    }
  };
  if (isRtl) {
    style.paddingRight = '16px';
  } else {
    style.paddingLeft = '16px';
  }
  return style;
});

//*********************************************
export class AppHeader extends PureComponent {
  componentWillMount = () => {
    this.setState({
      showUserMenu: false,
      showPrefsItem: true,
      renderLogoutWarning: false
    });
  };

  showHideUserMenu = (isCurrentlyShowing) => {
    if (isCurrentlyShowing) {
      this.hideUserMenu();
    } else {
      this.showUserMenu();
    }
  };

  showUserMenu = () => {
    this.setState({ showUserMenu: true });
    if (document.onclick) {
      document.onclick();
    }
    document.onclick = this.hideUserMenu;
  };
  hideUserMenu = () => {
    this.setState({ showUserMenu: false });
    document.onclick = null;
  };

  goToPreferences = () => {
    this.hideUserMenu();
    this.props.setPreferences();
  };

  doLogout = () => {
    if (this.props.showLogoutWarning) {
      // SHow warning dialog
      this.setState({ renderLogoutWarning: true });
    } else {
      this.hideUserMenu();
      this.props.logout();
    }
  };

  handleLogoutProceed = () => {
    this.setState({ renderLogoutWarning: false });
    this.hideUserMenu();
    this.props.logout();
  };

  handleLogoutCancel = () => {
    this.setState({
      renderLogoutWarning: false
    });
  };

  componentWillUpdate = () => {
    if (this.props.currentLocation.pathname.indexOf('objectives') >= 0) {
      this.setState({
        showPrefsItem: false
      });
    } else {
      this.setState({
        showPrefsItem: true
      });
    }
  };

  render = () => {
    if (!this.props.lionLoaded) {
      return null;
    }

    isRtl = this.props.isInterfaceRtl;
    const isMobile = isMobileDetected ? true : false;

    let userMenu = null;
    let logoutWarningDialog = null;
    let hasCatalyst = false;
    if (this.props.productRights) {
      this.props.productRights.forEach((productRight) => {
        if (isCatalyst(productRight.productId) || isCatalystAdmin(productRight.productId)) {
          hasCatalyst = true;
        }
      });
    }

    if (this.state.renderLogoutWarning) {
      logoutWarningDialog = (
        <ModalDialog
          headerText={this.props.logoutWarningHeader}
          bodyText={this.props.logoutWarningBody}
          okButtonText={this.props.getLionTranslatedString('quest_signout')}
          cancelButtonText={this.props.getLionTranslatedString('quest_cancel')}
          okButtonClickHandler={this.handleLogoutProceed}
          cancelButtonClickHandler={this.handleLogoutCancel}
        />
      );
    }
    let haveUser = this.props.userName;
    if (haveUser) {
      let dropdown = null;
      if (this.state.showUserMenu) {
        let prefsItem = null;
        if (this.state.showPrefsItem) {
          prefsItem = (
            <MenuItem data-qa="PrefsMenuItem" onClick={this.goToPreferences}>
              <LionTranslate lionkey="dropdown_editprofile" />
            </MenuItem>
          );
        }
        dropdown = (
          <Dropdown isMobile={isMobile}>
            <MenuList>
              {prefsItem}
              <MenuItem data-qa="LogoutMenuItem" onClick={this.doLogout}>
                <LionTranslate lionkey="dropdown_signout" />
              </MenuItem>
            </MenuList>
          </Dropdown>
        );
      }

      userMenu = (
        <UserMenu data-qa="UserMenu" isMobile={isMobile}>
          <MenuTop
            data-qa="UserMenuButton"
            isMobile={isMobile}
            onClick={() => {
              this.showHideUserMenu(this.state.showUserMenu);
            }}
          >
            <UserIcon />
            <DownArrow />
            <UserName data-qa="UserName" isMobile={isMobile}>
              {this.props.userName}
            </UserName>
          </MenuTop>
          {dropdown}
        </UserMenu>
      );
    }

    return (
      <AppHeaderDiv isMobile={isMobile}>
        <Logo isCatalyst={hasCatalyst} isMobile={isMobile} />
        {userMenu}
        {logoutWarningDialog}
      </AppHeaderDiv>
    );
  };
}

AppHeader.propTypes = {};

const mapStateToProps = (state, ownprops) => ({
  isInterfaceRtl: appSelectors.isInterfaceRtl(state),
  lionLoaded: lionSelectors.getLionAppResourcesLoaded(state),
  getLionTranslatedString: (key) => lionSelectors.getLionTranslatedString(state, key),
  userName: authSelectors.userName(state),
  showLogoutWarning: appSelectors.showLogoutWarning(state),
  logoutWarningHeader: appSelectors.logoutWarningHeader(state),
  logoutWarningBody: appSelectors.logoutWarningBody(state),
  currentLocation: getLocation(state),
  productRights: authSelectors.productRights(state)
});

const propActions = {
  logout: appActions.logoutUser,
  setPreferences: appActions.setPreferences,
  setUI: appActions.setInterfaceLanguage
};

export const AppHeaderContainer = connect(
  mapStateToProps,
  propActions
)(withWindowDimensions(AppHeader));



// WEBPACK FOOTER //
// ./src/modules/app/components/AppHeader.jsx